/**
 * ApexCharts の凡例クリックを Grafana 風の「アイソレート」挙動にする設定。
 *
 * 既定の ApexCharts はクリックした系列を隠す（残りが表示され続ける）が、
 * ここではクリックした系列だけを表示し、他を隠す。
 * すでにその系列だけが表示されている場合は全系列表示に戻す（トグル）。
 *
 * chart.events と legend.onItemClick に展開して使う:
 *   const opts = { ...base, ...legendIsolateOptions() }
 * ではなく、下記のように個別に差し込む（events / legend は他設定と同居するため）。
 */
export const legendIsolate = {
  // 既定のトグル（クリックで hide）を止め、legendClick 側で表示制御を握る
  onItemClick: { toggleDataSeries: false },
}

/** chart.events.legendClick に渡すハンドラ */
export const legendClickIsolate = (chartContext, seriesIndex, config) => {
  const names = config?.globals?.seriesNames ?? []
  if (names.length === 0) return

  // 現在隠れている系列インデックス
  const collapsed = config.globals.collapsedSeriesIndices ?? []
  const isVisible = (i) => !collapsed.includes(i)
  const visibleCount = names.filter((_, i) => isVisible(i)).length
  const clickedIsOnlyVisible = visibleCount === 1 && isVisible(seriesIndex)

  if (clickedIsOnlyVisible) {
    // すでにクリック系列だけ表示 → 全表示に戻す
    names.forEach((name) => chartContext.showSeries(name))
  } else {
    // クリック系列だけ表示し、他は隠す（アイソレート）
    names.forEach((name, i) => {
      if (i === seriesIndex) chartContext.showSeries(name)
      else chartContext.hideSeries(name)
    })
  }
}
